import {Tag} from "primeng/tag";
import {ApplicationStatus, HomeyStatus, NycProfileStatus, SubscriptionStatus, UserDto} from "admin-api-dto";

type SyncStatus = 'synced' | 'not-synced' | 'sync-failed' | 'sync-incomplete' | 'not-registered';

export type Severity = 'success' | 'secondary' | 'info' | 'warn' | 'danger' | 'contrast' | undefined

export function subscriptionStatusToTag(status: SubscriptionStatus): Severity {
  switch (status) {
    case "active":
      return 'success'
    case "trialing":
      return 'info';
    case "payment-pending":
      return 'warn';
    case "canceled":
    case "past_due":
    case "incomplete":
    case "incomplete_expired":
    case "paused":
    case "unpaid":
      return 'danger';
  }
}

export function paymentStatusToTag(status: 'paid' | 'not-paid'): Severity {
  switch (status) {
    case 'paid':
      return 'success';
    case 'not-paid':
      return 'danger';
  }
}

export function nycProfileStatusToTag(status: NycProfileStatus): Severity {
  switch (status) {
    case "waiting-on-email1-verification":
    case "waiting-on-email2-verification":
      return 'danger';
    case "complete":
      return 'success';
    case "profile-incomplete":
      return 'success';
    case "not-created":
      return 'warn';
  }
}

export function syncStatusToTag(status: SyncStatus): Severity {
  switch (status) {
    case "synced":
      return 'success';
    case "not-synced":
      return 'warn';
    case "sync-failed":
      return 'danger';
    case "sync-incomplete":
      return 'danger';
    case "not-registered":
      return 'warn';
  }
}

export function applicationStatusToTag(status: ApplicationStatus): Severity {
  switch (status) {
    case "not-selected":
      return 'success';
    case "selected":
      return 'success';
    case "failed":
      return 'danger';
    case "not-synced":
      return 'warn';
    case "applied":
      return 'success';
    case "pending-selection":
      return 'success';
  }
}

export function homeyStatusToTag(status: HomeyStatus): Severity {
  switch (status) {
    case "active":
      return 'success';
    case "signup-flow":
      return 'info';
    case "mandatory-flow":
      return 'warn';
  }
}

export function lastSyncStatusToTag(status: string): Severity {
  switch (status) {
    case 'sync-complete':
      return 'success';
    case 'sync-failed':
      return 'danger';
    case 'not-synced':
    default:
      return 'warn';
  }
}

export function loginStatusToTag(status: string): Severity {
  switch (status) {
    case 'login-correct':
      return 'success';
    case 'login-failed':
      return 'danger';
    default:
      return 'warn';
  }
}

export function loginFailedCountToTag(value: string): Severity {
  return Number(value) > 0 ? 'danger' : 'success';
}

export function syncFailedCountToTag(value: string): Severity {
  return Number(value) > 0 ? 'danger' : 'success';
}


